import { atom } from 'nanostores'
import type { TrialReminderGroup } from '~/features/multi-page/lib/trial-reminder'

const params = new URLSearchParams(window.location.search)

export const $debugAfterPaymentError = atom(
  params.has('debug_after_payment_error'),
)

// QA-only: simulate the same after-payment failure (which leaves a real,
// restorable store transaction) but suppress the auto restore dialog, so the
// standalone "Restore Purchases" button can be exercised on its own.
export const $debugAfterPaymentErrorSilent = atom(
  params.has('debug_after_payment_error_silent'),
)

// QA-only: force the trial reminder experiment arm from the DevTools panel so
// both arms can be walked on staging without native re-bucketing the user.
// Takes precedence over the arm native resolved.
export const $debugExperimentGroupOverride = atom<TrialReminderGroup | null>(
  null,
)
